import React from "react";
import "./performance.css";

const Performance = ({values, title, height = "332px"}) => {

  return (
    <div style={{height}} className="pvxPerformance">
      <div className="head">
        <div className="text">{title}</div>
        <img src="./images/PvxDashboard/Icons/Dots.svg" className="dots" alt="Dots" />
      </div>
      <div className="table">
        <div className="heading">
          <div>Name</div>
          <div>Values</div>
        </div>
        <div className="data">
          {values.map((val, index) => (
            <div className="row" key={index}>
              <span className="name">{val.name}</span>
              <span className="value">{val.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Performance;
